export default __webpack_public_path__ + "static/media/wayaBank.be7f0352.png";